import { createPortal } from 'react-dom';
import {
  RiCheckboxCircleLine,
  RiCloseLine,
  RiErrorWarningLine,
  RiInformationLine,
} from '@remixicon/react';
import { useToastStore, type ToastTone } from './toastStore';

const ICONS: Record<ToastTone, typeof RiCheckboxCircleLine> = {
  success: RiCheckboxCircleLine,
  danger: RiErrorWarningLine,
  info: RiInformationLine,
};

/** Uygulama kabuğuna bir kez yerleştirilir. */
export function ToastViewport() {
  const items = useToastStore((s) => s.items);
  const dismiss = useToastStore((s) => s.dismiss);

  if (items.length === 0) return null;

  return createPortal(
    <div className="mo-toasts" role="status" aria-live="polite">
      {items.map((t) => {
        const Icon = ICONS[t.tone];
        return (
          <div key={t.id} className={`mo-toast mo-toast--${t.tone}`}>
            <Icon size={18} className="mo-toast__icon" aria-hidden="true" />
            <div className="mo-toast__body">
              <div className="mo-toast__title">{t.title}</div>
              {t.description && <div className="mo-toast__desc">{t.description}</div>}
            </div>
            <button
              type="button"
              className="mo-toast__close"
              onClick={() => dismiss(t.id)}
              aria-label="Bildirimi kapat"
            >
              <RiCloseLine size={14} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>,
    document.body,
  );
}
